export const ME_ACCOUNT_ID = 'me';
